import { render } from "./List.vue?vue&type=template&id=c6becca0"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
script.render = render

export default script